import { Map } from '@Models';

export class MapView {
  id: string;
  initials: string;
  name: string;
  map: Map | null;
  mapId: number | null;
  selectable: boolean;
  selected: boolean;

  constructor(params: MapViewParams) {
    this.id = params.id;
    this.initials = params.initials;
    this.name = params.name;
    this.map = params.map;
    this.mapId = params.mapId;
    this.selectable = params.selectable;
    this.selected = params.selected;
  }

  public static fromMap(
    item: Map,
    selectable: boolean = false,
    selected: boolean = false,
  ): MapView {
    return new MapView({
      id: '',
      mapId: item.id,
      map: item,
      initials: item.initials,
      name: item.name,
      selectable: selectable,
      selected: selected,
    });
  }
  public static empty(): MapView {
    return new MapView({
      id: '',
      mapId: null,
      map: null,
      initials: '',
      name: '',
      selectable: false,
      selected: false,
    });
  }
}

type MapViewParams = {
  id: string;
  initials: string;
  name: string;
  map: Map | null;
  mapId: number | null;
  selectable: boolean;
  selected: boolean;
};
